import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useIntl } from "react-intl";
import { useLoading } from "../components/LoadingContext";
import { handleError, errorToast } from "../services/serviceBase";
import axios from "../api/axiosClient";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ggImage from "../img/GG.svg";
import balImage from "../img/BAL.svg";
import bvImage from "../img/BV.svg";
import briImage from "../img/BRI.png";
import yslImage from "../img/SL.png";
import amqImage from "../img/AMQ.png";
import { useNavigate } from "react-router-dom";
import { setCurrentItemMenuId } from "../redux/commonSlice";

const NavigationHeader = (props) => {
  const intl = useIntl();
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const company = useSelector((state) => state.common.company);
  const customerCode = useSelector((state) => state.actas.customerCode);
  const customerDescription = useSelector(
    (state) => state.actas.customerDescription
  );
  const jdaLocationCode = useSelector((state) => state.actas.jdaLocationCode);
  const jdaLocationDescription = useSelector(
    (state) => state.actas.jdaLocationDescription
  );
  const shopCode = useSelector((state) => state.actas.shopCode);
  const shopDescription = useSelector((state) => state.actas.shopDescription);

  const [selectedCompany, setSelectedCompany] = useState(null);

  useEffect(() => {
    if (company !== 0) {
      setSelectedCompany(company);
    }
  }, [company]);

  const handleHelpClick = () => {
    setLoading(true);
    axios
      .get("/generalinformation/usermanual")
      .then((response) => {
        setLoading(false);
        if (response.data !== null && response.data !== undefined) {
          var url =
            response.data.deployWebsitePath + response.data.userManualFilePath;
          window.open(url, "_blank");
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleHomeClik = () => {
    navigate("/");
    dispatch(setCurrentItemMenuId(0));
  };

  const getImageSrc = () => {
    switch (selectedCompany) {
      case 28:
        return bvImage;
      case 20:
        return ggImage;
      case 27:
        return balImage;
      case 23:
        return yslImage;
      case 25:
        return amqImage;
      case 22:
        return briImage;
      default:
        return null;
    }
  };

  return (
    <AppBar
      position="fixed"
      id="navigationHeader"
      className="apeLigthBlueBackground"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Container maxWidth="false">
        <Toolbar disableGutters>
          <IconButton
            onClick={props.handleDrawerToggle}
            edge="start"
            sx={{ color: "black" }}
          >
            <MenuIcon />
          </IconButton>
          <img
            width="150px"
            src={getImageSrc()}
            onClick={handleHomeClik}
            style={{ paddingLeft: "20px" }}
          />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, pl: 5 }}>
            EVO Reverse
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            {customerCode !== null ? (
              <ul
                style={{ margin: 0, listStyleType: "none", textAlign: "right" }}
              >
                <li>
                  <Typography variant="subtitle2">
                    <strong>
                      {intl.formatMessage({ id: "General.Customer" })}:
                    </strong>{" "}
                    {customerCode} - {customerDescription}
                  </Typography>
                </li>
                <li>
                  {shopCode !== null ? (
                    <Typography variant="subtitle2">
                      <strong>
                        {intl.formatMessage({ id: "RASearch.Door" })}:
                      </strong>
                      {shopCode} - {shopDescription}
                    </Typography>
                  ) : (
                    <Typography variant="subtitle2">
                      <strong>
                        {intl.formatMessage({ id: "RASearch.Door" })}:
                      </strong>
                      -
                    </Typography>
                  )}
                </li>
                <li>
                  {jdaLocationCode !== null ? (
                    <Typography variant="subtitle2">
                      <strong>
                        {intl.formatMessage({ id: "RASearch.JdaLocation" })}:
                      </strong>{" "}
                      {jdaLocationCode} - {jdaLocationDescription}
                    </Typography>
                  ) : (
                    <Typography variant="subtitle2">
                      <strong>
                        {intl.formatMessage({ id: "RASearch.JdaLocation" })}:
                      </strong>{" "}
                      -
                    </Typography>
                  )}
                </li>
              </ul>
            ) : null}
          </Box>
          <Box sx={{ flexGrow: 0, pl: 2 }}>
            <Button
              startIcon={<HelpOutlineIcon />}
              sx={{ color: "black" }}
              onClick={handleHelpClick}
            >
              {intl.formatMessage({ id: "General.Help" })}
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default NavigationHeader;
